import React from 'react';
import OrderListTemplate from '../components/OrderListTemplate';
import { MergedOrder, OrderTabScene } from '../../../types/process/order';
import OrderTriggerActionMap, { OrderTriggerActionProvider, type OrderTriggerTarget } from '../components/OrderTriggerActionMap';
import { useDefaultQueryFields } from '../order.effect';

const PendingDecisionList: React.FC = () => {
  const tabScene = OrderTabScene.GroupDecision;
  const queryFields = useDefaultQueryFields(tabScene);

  const targets: OrderTriggerTarget[] = ['reportView', 'orderReaudit'];

  const renderTableActions = (order: MergedOrder) => (
    <OrderTriggerActionMap layout="list" targets={targets} order={order} />
  );

  return (
    <OrderTriggerActionProvider>
      <OrderListTemplate
        tabScene={tabScene}
        defaultScene='tab_decision_all'
        queryFields={queryFields}
        viewModes={[
          {
            mode: 'list',
            label: '产品页',
            renderActions: renderTableActions,
          },
        ]}
      />
    </OrderTriggerActionProvider>
  );
};

export default PendingDecisionList;
